import { withInstall } from '@vuesax-plus/utils'
import Button from './src/button.vue'

export const VsButton = withInstall(Button)
export default VsButton

export * from './src/button'
